import { collection, query, orderBy } from 'firebase/firestore';
import { useFirestore, useFirestoreCollection } from 'reactfire';

// 2026-08-19: fetches the full `titles` collection once (just the pieces the
// duplicate-title check on Add Title needs -- id/title/release_date -- though
// Firestore always returns whole docs, so this discards everything else client-side).
// ~1900 docs, admin-tool-only, matches the existing precedent of useGenres/useTags
// fetching their whole collections unfiltered.
export function useAllTitlesLite() {
    const firestore = useFirestore();
    const titlesCollection = collection(firestore, 'titles');
    const activeQuery = query(titlesCollection, orderBy('title_sort', 'asc'));

    const { status, data: titleDocs } = useFirestoreCollection(activeQuery);

    if (status === 'loading') {
        return undefined;
    }

    const titles = [];
    titleDocs.forEach(doc => {
        const data = doc.data();
        titles.push({
            id: doc.id,
            title: data.title,
            release_date: data.release_date ? data.release_date.toDate() : undefined,
        });
    });

    return titles;
}
